import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientDataInputView } from "../PatientDataInputView";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { useDataInputPanels } from "../useDataInputPanels";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { KahunPanelSubGroup } from "shared";
// import { useState } from "react";

//region [[ Styles ]]

const DataEntrySectionView = styled("div")(({ theme }) => ({
  margin: "-7px", // Kill the contentWrapper 7px padding
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DataEntrySectionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DataEntrySection = ({ ...props }: DataEntrySectionProps) => {
  const { panels, loading } = useDataInputPanels();
  const match = useRouteMatch();
  // Clean "/" from path in the end if exists
  const matchPath = removeTrailingSlash(match.path);

  const history = useHistory();

  const onChangeSection = (newSection: PatientCaseGrouping) => {
    history.push(`${matchPath}/${newSection}`);
  };

  return (
    <DataEntrySectionView>
      <Switch>
        <Route
          path={`${matchPath}/:section?/:tab?/:panelId?`}
          exact
          render={(props) => {
            const params = props.match.params as {
              tab?: string;
              section?: PatientCaseGrouping;
            };
            const subGroup = params.tab;
            const subGroupId = subGroup ? KahunPanelSubGroup[subGroup] : null;
            const panelId = (props.match.params as { panelId?: string })
              .panelId;
            const section =
              params.section || PatientCaseGrouping.CLINICAL_FEATURES;
            return (
              <PatientDataInputView
                panels={panels}
                loading={loading}
                section={section}
                panelId={panelId}
                showTabs={true}
                categoryid={subGroupId}
                onChangeSection={onChangeSection}
              />
            );
          }}
        />
      </Switch>
    </DataEntrySectionView>
  );
};
